module.exports = __webpack_public_path__ + "static/BackHome1-89e314bb7c6613fb23287f546e669e66.jpeg";